import { getCoreDataSecurityApiVolumeByApplicationSlice } from './get';

export const { requestGetCoreDataSecurityApiVolumeByApplication, resetGetCoreDataSecurityApiVolumeByApplication } =
    getCoreDataSecurityApiVolumeByApplicationSlice.asyncActionCreators;
